import { render, staticRenderFns } from "./ProjectSlider.vue?vue&type=template&id=135b280d&scoped=true&"
import script from "./ProjectSlider.vue?vue&type=script&lang=ts&"
export * from "./ProjectSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSlider.vue?vue&type=style&index=0&id=135b280d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b280d",
  null
  
)

export default component.exports